<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h3 class="m-0">Solicitações de Reembolsos</h3>
          <button
            class="btn btn-primary"
            @click="handleNewReimbursementClick"
            :class="{ 'opacity-50': hasPendingReimbursements }"
          >
            Nova Solicitação de Reembolso
          </button>
        </div>
        <div v-if="date" class="mb-2">
          <small class="text-muted">
            Filtro de data ativo: <b>{{ date }}</b>
          </small>
        </div>

        <base-crud
          :ref="'reimbursementSolicitationsCrud'"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="isAccessNivel"
          :enableDelete="isAccessNivel"
          :enableView="false"
          :enableDownload="true"
          :dataForm="dataForm"
          :extra="extra"
          @view="view"
          :customFilters="customFilters"
          @filtered_ds="filtered_ds"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import { REIMBURSEMENT_STATUS_LABELS, reimbursementStatusBadge } from "../../utils/expenseStatus";
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      stateKey: "reimbursement_solicitations_list_state",
      hasPendingReimbursements: false,
      customFilters: [
        {
          name: "date_f",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      date: "",
      table: "reimbursementSolicitationsTable",
      showMessageImport: false,
      reimbursementSolicitationsCrud: {},
      pages: [],
      url: "",
      columns: ["id", "user_id", "approve", "date_f", "balance_to_receive", "actions"],
      tableData: [
        "id",
        "user_id",
        "date_f",
        "expense_description",
        "amount",
        "advance_amount",
        "total_expenses",
        "balance_to_receive",
        "deposit_bank",
        "branch",
        "checking_account",
        "bill_center_id",
        "approve",
        "date_approve",
      ],
      options: {
        saveState: true,
        storage: "local",
        filterByColumn: true,
        debounce: 1000,
        filterable: ["user_id", "approve"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Colaborador",
          balance_to_receive: "Valor",
          approve: "Status",
          date_f: "Data da solicitação",
          actions: "Ações",
        },
        sortable: ["id"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          approve: Object.keys(REIMBURSEMENT_STATUS_LABELS).map((id) => ({
            id: Number(id),
            text: REIMBURSEMENT_STATUS_LABELS[id].text,
          })),
        },
        templates: {
          approve: function (h, row) {
            const status = reimbursementStatusBadge(row.approve, row.accountability_result);
            return h("h6", { class: "text-center" }, [
              h("span", { class: `badge ${status.badge}` }, status.text),
              row.is_contested ? h("span", { class: "badge badge-warning ml-50" }, "CONTESTADO") : null,
            ]);
          },

          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          balance_to_receive: function (h, row) {
            // Se foi tudo reprovado, não há valor a reembolsar/devolver
            const value = Number(row.approve) === 2
              ? 0
              : Math.abs(row.balance_to_receive || 0);

            return new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(value);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          query +=
            "&with[]=user&with[]=reimbursement_action_histories&with[]=reimbursements";

          if (
            this.$parent.$parent.$parent.date != null &&
            this.$parent.$parent.$parent.date != ""
          ) {
            requestData.params.date = this.$parent.$parent.$parent.date;
          }

          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "reimbursement_solicitations/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },

  created() {
    this.restoreState(); // ✅ restaura o filtro ANTES do BaseCrud montar
  },

  mounted() {
    this.checkPendingReimbursements();

    if (this.date) {
      this.$nextTick(() => this.refreshCrud()); // ✅ garante a tabela com filtro restaurado
    }
  },
  methods: {
    persistState() {
      localStorage.setItem(
        this.stateKey,
        JSON.stringify({
          date: this.date,
        })
      );
    },

    restoreState() {
      const raw = localStorage.getItem(this.stateKey);
      if (!raw) return;

      try {
        const saved = JSON.parse(raw);
        if (saved && "date" in saved) this.date = saved.date;
      } catch (e) {}
    },

    refreshCrud() {
      const crud = this.$refs.reimbursementSolicitationsCrud;
      if (!crud) return;

      const tableRef = crud.$refs?.[this.table];
      if (tableRef?.refresh) return tableRef.refresh();

      if (crud.refresh) return crud.refresh();
      if (crud.getData) return crud.getData();
    },

    filtered_ds(date) {
      this.date = date;
      this.persistState(); // ✅ salva a data
      this.$nextTick(() => this.refreshCrud()); // ✅ recarrega a tabela com a data
    },

    view(props, row, index) {
      this.persistState(); // ✅ salva o filtro antes de sair da tela
      this.$router.push("/reimbursement_solicitations/view/" + props.row.id);
    },
    checkPendingReimbursements() {
      const api = this.$store.state.api + "reimbursement_solicitations";
      const userId = this.$store.state.user.id;

      axios
        .get(api + "?user_id=" + userId)
        .then((response) => {
          const reimbursements = response.data.data;
          this.hasPendingReimbursements = reimbursements.some(
            (r) => r.approve === 4
          );
        })
        .catch((error) => {
          this.$message(
            null,
            error.response?.data || "Erro ao verificar reembolsos pendentes",
            "error"
          );
        });
    },
    handleNewReimbursementClick() {
      if (this.hasPendingReimbursements) {
        this.$message(
          "Ação não permitida",
          "Você não pode abrir novas solicitações de reembolso porque ainda tem outras pendentes para preencher.",
          "warning"
        );
      } else {
        this.$router.push("/reimbursement_solicitations/add");
      }
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        approve: "approve",
      };
      let filters = "&orderByDesc=id&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },

  computed: {
    isAccessNivel() {
      return (
        this.$store.state.user.perfil_id === 7 ||
        this.$store.state.user.perfil_id === 8 ||
        this.$store.state.user.perfil_id === 12 ||
        this.$store.state.user.perfil_id === 20
      );
    },
    extra() {
      // Todos podem visualizar; o backend já limita o usuário padrão às próprias solicitações
      return [
        {
          id: 1,
          label: "",
          class: "btn btn-crud view",
          title: "Visualizar",
          name: "view",
          icon: "fas fa-eye",
        },
      ];
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
